import { AppTour } from '../tour.model';

/**
 * Coach-mark shown once on the profile-menu close (X) button, only when the user
 * arrives from the post-activation "View PO" button. Points at the close icon and
 * tells the user that closing takes them to the Dashboard. Rendered as a parallel
 * (non-blocking) tour so it behaves like the other in-app guides (e.g. the expense
 * category "Add Category" coach-mark).
 */
export const PROFILE_CLOSE_BUTTON_TOUR: AppTour = {
  tourId: 'profile-close-button-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'profile-close-button-tour',
      attachTo: { element: '#profile-close-guide', on: 'bottom-end' },
      cancelIcon: { enabled: false },
      title: 'new_onb_close_dashboard_tooltip_title',
      text: 'new_onb_close_dashboard_tooltip_desc',
      parallel: true
    }
  ]
};
